import SetPassword from "./setpassword";

export default SetPassword;
